/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, Input } from "@angular/core";

import { ThemeType } from "@ant-design/icons-angular";

import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzFormDirective } from "ng-zorro-antd/form";
import { uiDefaultTooltipIcon, UiFormLayoutType } from "@webapp/ui/form/form.models";
@Directive({
  selector: "[ui-form]",
  exportAs: "uiForm",
})
export class UiFormDirective extends NzFormDirective {
  @Input("uiLayout") public nzLayout: UiFormLayoutType = "horizontal";
  @Input("uiNoColon") @WithConfig() @InputBoolean() public nzNoColon = false;
  @Input("uiAutoTips") @WithConfig() public nzAutoTips: Record<string, Record<string, string>> = {};
  @Input("uiDisableAutoTips") @InputBoolean() public nzDisableAutoTips = false;
  @Input("uiTooltipIcon") @WithConfig() public nzTooltipIcon: string | { type: string; theme: ThemeType } = uiDefaultTooltipIcon;
}
